import { EmployeeBenefitType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import {
  AssignBeneficiaryDto,
  Benefit,
  Benefits
} from 'service/dto/employee-benefit.dto';
import { BeneficiariesAllocationDto } from 'service/dto/general.dto';
import { errorHandler } from 'utils';

class EmployeeService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createEmployeeBenefit = async (employeeBenefitType: EmployeeBenefitType) => {
    try {
      const response = await this.baseService.post(
        '/employer-benefit/create',
        employeeBenefitType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getEmployeeBenefits = async (): Promise<Benefits> => {
    try {
      const response = await this.baseService.get('/employer-benefit');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getEmployeeBenefit = async (benefitId: number): Promise<Benefit> => {
    try {
      const response = await this.baseService.get(
        `/employer-benefit/${benefitId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteEmployeeBenefit = async (benefitId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/employer-benefit/${benefitId}`
      );
      return response.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBeneficiary = async (assignBeneficiaryDto: AssignBeneficiaryDto) => {
    try {
      const response = await this.baseService.patch(
        '/employer-benefit/assign-to-beneficiary',
        assignBeneficiaryDto
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  unAssignEmployeeBenefitBeneficiary = async (
    allocationId?: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/employer-benefit/unassign-beneficiary/${allocationId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  editBulkEmployeeBenefitBeneficiary = async (
    beneficiariesAllocationDto?: BeneficiariesAllocationDto
  ): Promise<void> => {
    try {
      const response = await this.baseService.patch(
        `/employer-benefit/bulk-edit-beneficiary-assign`,
        beneficiariesAllocationDto
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  removeBenefitTrustee = async (
    assetId: number,
    trusteeId: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/employer-benefit/unassign-trustee/${assetId}/${trusteeId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBenefitTrustee = async (
    assetId: number[],
    trusteeId: number,
    note: string
  ): Promise<void> => {
    try {
      const response = await this.baseService.put(
        `/employer-benefit/assign/bulk-trustee`,
        {
          assetId,
          trusteeId,
          note
        }
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default EmployeeService;
